import {
    SET_SCANME_DATA,
    RESET_SCANME_DATA
} from '../actionTypes';

// Initial state for the scanme feature slice
// Only holds the data itself now
export const scanmeInitialState = {
    travellerData: null,
};

// The reducer function for the scanme feature
export default (state = scanmeInitialState, action) => {
    switch (action.type) {
        case SET_SCANME_DATA:
            // When data is set, update the travellerData in the state
            return {
                ...state,
                travellerData: action.payload, // Store the data from the action
            };

        case RESET_SCANME_DATA:
            // Reset the state to its initial value
            return {
                ...scanmeInitialState
            };

        default:
            // Return the current state for any other actions
            return state;
    }
}